import React, { useContext } from "react";
import { BellIcon, SearchIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Avatar,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
  useToast,
  useBreakpointValue,
  Text
} from "@chakra-ui/react";
import avatar4 from "assets/img/avatars/avatar4.png";
// Custom Icons
import {ThemeChangeIcon, InformationIcon, NewChatButton } from "components/Icons/Icons";
// Custom Components
import SidebarResponsive from "components/Sidebar/SidebarResponsive";
import PropTypes from "prop-types";
import routes from "routes.js";
import { AppContext } from "../../context/AppContext";
export default function HeaderLinks(props) {
  const toast = useToast()
  const { variant, children, fixed, secondary, onOpen, ...rest } = props;
  const size = useBreakpointValue({ sm: "sm", md: "md", lg: "lg" });
  const { 
    setMessages, 
    setResponseMessages, 
    setShowSuggestions,
        } = useContext(AppContext);
  // Chakra Color Mode
  let mainTeal = useColorModeValue("teal.300", "teal.300");
  let inputBg = useColorModeValue("white", "gray.800");
  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  let searchIcon = useColorModeValue("gray.700", "gray.200");

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
  const settingsRef = React.useRef();
  return (
    <>
    { size == ("lg" || "md")  ?
    <></>
    // <Flex
    //   pe={{ sm: "0px", md: "16px" }}
    //   w={{ sm: "fit-content", md: "auto" }}
    //   alignItems="center"
    //   flexDirection="row"
    //   boxShadow='0 20px 27px 0 rgb(0 0 0 / 5%)'
    //   p="2"
    //   borderRadius="full"
    // >
    //   <InputGroup
    //     cursor="pointer"
    //     bg={inputBg}
    //     borderRadius="15px"
    //     w={{
    //       sm: "128px",
    //       md: "200px",
    //     }}
    //     me={{ sm: "auto", md: "20px" }}
    //     _focus={{
    //       borderColor: { mainTeal },
    //     }}
    //     _active={{
    //       borderColor: { mainTeal },
    //     }}
    //   >
    //     <InputLeftElement
    //       children={
    //         <IconButton
    //           bg="inherit"
    //           borderRadius="inherit"
    //           _hover="none"
    //           _active={{
    //             bg: "inherit",
    //             transform: "none",
    //             borderColor: "transparent",
    //           }}
    //           _focus={{
    //             boxShadow: "none",
    //           }}
    //           onClick={() =>
    //             toast({
    //               title: `This Feature is Coming Soon`,
    //               position: 'top',
    //               isClosable: true,
    //             })
    //           }
    //           icon={<SearchIcon color={searchIcon} w="15px" h="15px" />}
    //         ></IconButton>
    //       }
    //     />
    //     <Input
    //       bgColor="#F4F7FE"
    //       fontSize="xs"
    //       py="11px"
    //       color={mainText}
    //       placeholder="Search"
    //       borderRadius="inherit"
    //       onClick={() =>
    //         toast({
    //           title: `This Feature is Coming Soon`,
    //           position: 'top',
    //           isClosable: true,
    //         })
    //       }
    //       readOnly
    //       _focus={{
    //         outline: "none", // Prevent blue outline
    //         boxShadow: "none", // Prevent focus shadow
    //       }}
    //     />
    //   </InputGroup>
    //       <BellIcon 
    //         color={navbarIcon} 
    //         w="18px" 
    //         h="18px" 
    //         cursor="pointer" 
    //         mr="10px"
    //         onClick={() =>
    //           toast({
    //             title: `This Feature is Coming Soon`,
    //             position: 'top',
    //             isClosable: true,
    //           })
    //         }
    //         />
    //       <ThemeChangeIcon 
    //         color={navbarIcon} 
    //         w="18px" 
    //         h="18px" 
    //         cursor="pointer" 
    //         mr="7px" 
    //         mt="5px"
    //         onClick={() =>
    //           toast({
    //             title: `This Feature is Coming Soon`,
    //             position: 'top',
    //             isClosable: true,
    //           })
    //         }
    //         /> 
    //       <InformationIcon 
    //         color={navbarIcon} 
    //         w="18px" 
    //         h="18px" 
    //         cursor="pointer" 
    //         mr="10px" 
    //         mt="2px"
    //         onClick={() =>
    //           toast({
    //             title: `This Feature is Coming Soon`,
    //             position: 'top',
    //             isClosable: true,
    //           })
    //         }
    //         />
    //         <SidebarResponsive
    //           logoText={props.logoText}
    //           secondary={props.secondary}
    //           routes={routes}
    //           // logo={logo}
    //           {...rest}

    //         />
    //       <Avatar
    //         src={avatar4}
    //         w="30px"
    //         h="30px"
    //         cursor="pointer"
    //         ml="10px" 
    //         onClick={() =>
    //           toast({
    //             title: `This Feature is Coming Soon`,
    //             position: 'top',
    //             isClosable: true,
    //           })
    //         }
    //         />
    // </Flex>
     : 
     <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      // boxShadow='0 20px 27px 0 rgb(0 0 0 / 5%)'
      p="2"
      borderRadius="full"
    >
      <SidebarResponsive
              logoText={props.logoText}
              secondary={props.secondary}
              routes={routes}
              // logo={logo}
              {...rest}

            />
      <Text 
        fontSize="17px"
        fontWeight="600"
        lineHeight="22px"
        textAlign="center"
        >
        GRID AI
      </Text>
     <NewChatButton
      height="20px"
      width="20px"
      onClick={() => { 
        setResponseMessages([]);
        setMessages([]);
        setShowSuggestions(true);
      }}
     />   
     </Flex>
     }
   </>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
